import React, { useEffect } from 'react';
import './SoftwareDevelopment.css'
// import AOS from 'aos';
// import 'aos/dist/aos.css';


const SoftwareDevelopment = () => {
  // useEffect(() => {
  //   AOS.init({
  //     duration: 1000,
  //     once: true,
  //     easing: 'ease-out-cubic'
  //   });

  //   // Smooth scroll for in-page links
  //   const handleSmoothScroll = (e) => {
  //     const href = e.target.getAttribute('href');
  //     if (href && href.startsWith('#')) {
  //       e.preventDefault();
  //       const target = document.querySelector(href);
  //       if (target) {
  //         target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //       }
  //     }
  //   };

  //   const links = document.querySelectorAll('.nav-links a, .mobile-nav a');
  //   links.forEach(link => link.addEventListener('click', handleSmoothScroll));

  //   // Active link highlight on scroll
  //   const sections = document.querySelectorAll('section[id]');
  //   const setActiveLink = () => {
  //     const scrollPos = window.scrollY + 120; // offset for fixed navbar
  //     let currentId = 'hero';
  //     sections.forEach(sec => {
  //       if (scrollPos >= sec.offsetTop && scrollPos < sec.offsetTop + sec.offsetHeight) {
  //         currentId = sec.id;
  //       }
  //     });
  //     links.forEach(a => {
  //       a.classList.toggle('active', a.getAttribute('href') === `#${currentId}`);
  //     });
  //   };

  //   window.addEventListener('scroll', setActiveLink);
  //   setActiveLink(); // Initial call

  //   // Cleanup
  //   return () => {
  //     links.forEach(link => link.removeEventListener('click', handleSmoothScroll));
  //     window.removeEventListener('scroll', setActiveLink);
  //   };
  // }, []);

  

  return (
    <div>
      <section id="hero" className="sd-hero">
        <div className="sd-hero-content" data-aos="fade-up">
          <h1>Software Development</h1>
          <h2>Engineer Your Competitive Edge with Tailored Software Solutions</h2>
          <p>Is your business constrained by generic, off-the-shelf software? At Oakya IT Services, we craft custom software applications designed to fit your unique processes, overcome specific challenges, and unlock new opportunities for growth. We transform your vision into a powerful digital asset that drives efficiency, engages customers, and delivers a measurable return on investment.</p>
          <a href="mailto:info@oakyaitservices.com" className="sd-btn">Get Your Free Consultation →</a>
        </div>
      </section>
      <section id="solutions" className="sd-solution">
        <h2 data-aos="fade-up">Your Business Challenges, Our Expert Solutions</h2>
        <div className="sd-solution-cards">
          <div className="sd-solution-card" data-aos="zoom-in">
            <i className="fas fa-expand"></i>
            <h3>Outgrown existing systems?</h3>
            <p>We build scalable and flexible platforms that evolve with your business, ensuring seamless growth without disruption.</p>
          </div>
          <div className="sd-solution-card" data-aos="zoom-in">
            <i className="fas fa-cogs"></i>
            <h3>Inefficient workflows slowing you down?</h3>
            <p>Our automation solutions streamline processes, reducing manual effort and boosting productivity across teams.</p>
          </div>
          <div className="sd-solution-card" data-aos="zoom-in">
            <i className="fas fa-mobile-alt"></i>
            <h3>Looking for a unique customer experience?</h3>
            <p>We design and develop engaging web and mobile applications that captivate users and differentiate your brand.</p>
          </div>
        </div>
      </section>
      <section id="expertise" className="sd-expertise">
        <h2 data-aos="fade-up">Comprehensive Software Development Expertise</h2>
        <div className="sd-expertise-cards">
          <div className="sd-expertise-card" data-aos="fade-right">
            <i className="fas fa-laptop-code"></i>
            <h3>Custom Web Application Development</h3>
            <p>Powerful, secure, scalable solutions for teams & customers.</p>
          </div>
          <div className="sd-expertise-card" data-aos="fade-up">
            <i className="fas fa-network-wired"></i>
            <h3>Enterprise Software Solutions</h3>
            <p>ERP, CRM & automation tools that streamline operations.</p>
          </div>
          <div className="sd-expertise-card" data-aos="fade-left">
            <i className="fas fa-pencil-ruler"></i>
            <h3>UI/UX Design</h3>
            <p>
              Intuitive, user-focused design that drives adoption.
            </p>
          </div>
          <div className="sd-expertise-card" data-aos="fade-right">
            <i className="fas fa-cloud"></i>
            <h3>DevOps & Cloud Services</h3>
            <p>Intuitive, user-focused design that drives adoption.</p>
          </div>
          <div className="sd-expertise-card" data-aos="fade-left">
            <i className="fas fa-shield-alt"></i>
            <h3>Quality Assurance & Testing</h3>
            <p>Comprehensive strategies for security & reliability.</p>
          </div>
        </div>
      </section>
      <section id="methodologies" className="sd-methodologies">
        <h2 data-aos="fade-up">Development Methodologies</h2>
        <div className="sd-method-grid">
          <div className="sd-method" data-aos="fade-right">
            <h3>Agile Methodology: Flexible, Transparent, Value-Driven</h3>
            <p>At Oakya, we follow Agile practices to ensure your software evolves with your business needs. Through short sprints, regular feedback loops, and continuous improvement, we deliver features faster while keeping you in the driver’s seat. Our collaborative approach means you see progress in real-time, adapt quickly to changes, and always get a solution aligned with your goals.</p>
          </div>
          <div className="sd-method" data-aos="fade-left">
            <h3>Waterfall Methodology: Structured, Step-by-Step, Reliable</h3>
            <p>For projects that need a clear roadmap from the start, Oakya also applies the Waterfall approach. Each phase, planning, design, development, testing, and deployment, is completed in sequence, ensuring thorough documentation, predictable timelines, and reliable delivery for well-defined requirements.</p>
          </div>
        </div>
      </section>
      <section id="technologies" className="sd-technologies">
        <div className="sd-container">
          <h2 className="sd-section-title" data-aos="fade-up">Technologies We Use</h2>
          <div className="sd-tech-groups">
            <div className="sd-tech-group" data-aos="fade-up">
              <h3>Frontend</h3>
              <div className="sd-tech-grid">
                <div className="sd-tech"><i className="fa-brands fa-react"></i><span>React</span></div>
                <div className="sd-tech"><i className="fa-brands fa-angular"></i><span>Angular</span></div>
                <div className="sd-tech"><i className="fa-brands fa-js"></i><span>JavaScript</span></div>
                <div className="sd-tech"><i className="fa-brands fa-css3-alt"></i><span>CSS</span></div>
                <div className="sd-tech"><i className="fa-brands fa-html5"></i><span>HTML</span></div>
                <div className="sd-tech"><i className="fa-solid fa-code"></i><span>ASP.NET MVC</span></div>
              </div>
            </div>
            <div className="sd-tech-group" data-aos="fade-up" data-aos-delay="100">
              <h3>Backend</h3>
              <div className="sd-tech-grid">
                <div className="sd-tech"><i className="fa-brands fa-node"></i><span>Node.js</span></div>
                <div className="sd-tech"><i className="fa-solid fa-code-branch"></i><span>C# .NET</span></div>
                <div className="sd-tech"><i className="fa-solid fa-leaf"></i><span>Spring Boot</span></div>
                <div className="sd-tech"><i className="fa-brands fa-php"></i><span>PHP</span></div>
                <div className="sd-tech"><i className="fa-brands fa-python"></i><span>Python</span></div>
              </div>
            </div>
            <div className="sd-tech-group" data-aos="fade-up" data-aos-delay="200">
              <h3>Cloud & DevOps</h3>
              <div className="sd-tech-grid">
                <div className="sd-tech"><i className="fa-brands fa-aws"></i><span>AWS</span></div>
                <div className="sd-tech"><i className="fa-brands fa-microsoft"></i><span>Azure</span></div>
                <div className="sd-tech"><i className="fa-brands fa-google"></i><span>GCP</span></div>
                <div className="sd-tech"><i className="fa-solid fa-arrows-rotate"></i><span>CI/CD</span></div>
                <div className="sd-tech"><i className="fa-solid fa-shield-halved"></i><span>Security</span></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="process" className="sd-process">
        <div className="sd-container">
          <h2 className="sd-section-title" data-aos="fade-up">Our Development Process</h2>
          <div className="sd-timeline">
            <div className="sd-timeline-item" data-aos="fade-up">
              <div className="sd-timeline-num">1</div>
              <div className="sd-timeline-content">
                <h3>Discover & Plan</h3>
                <p>We dive deep into your business goals, challenges, and technical requirements.</p>
              </div>
            </div>
            <div className="sd-timeline-item" data-aos="fade-up" data-aos-delay="100">
              <div className="sd-timeline-num">2</div>
              <div className="sd-timeline-content">
                <h3>Design & Prototype</h3>
                <p>Wireframes & prototypes for your feedback, ensuring alignment before build.</p>
              </div>
            </div>
            <div className="sd-timeline-item" data-aos="fade-up" data-aos-delay="200">
              <div className="sd-timeline-num">3</div>
              <div className="sd-timeline-content">
                <h3>Develop & Iterate</h3>
                <p>Agile sprints with regular demos—fast feedback, predictable progress.</p>
              </div>
            </div>
            <div className="sd-timeline-item" data-aos="fade-up" data-aos-delay="300">
              <div className="sd-timeline-num">4</div>
              <div className="sd-timeline-content">
                <h3>Test & Deploy</h3>
                <p>Rigorous testing and smooth releases for performance and reliability.</p>
              </div>
            </div>
            <div className="sd-timeline-item" data-aos="fade-up" data-aos-delay="400">
              <div className="sd-timeline-num">5</div>
              <div className="sd-timeline-content">
                <h3>Support & Evolve</h3>
                <p>Ongoing maintenance and enhancements to keep you at peak performance.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

       <section id="why-us" className="sd-why-us">
        <h2 data-aos="fade-up">Why Choose Oakya?</h2>
        <div className="sd-why-us-cards">
          <div className="sd-why-us-card" data-aos="zoom-in"><i className="fas fa-code"></i><span> Deep Technical Expertise</span></div>
          <div className="sd-why-us-card" data-aos="zoom-in"><i className="fas fa-users"></i><span> Client-Centric Approach</span></div>
          <div className="sd-why-us-card" data-aos="zoom-in"><i className="fas fa-sync"></i><span> Agile & Flexible</span></div>
          <div className="sd-why-us-card" data-aos="zoom-in"><i className="fas fa-lock"></i><span> Focus on Quality</span></div>
          <div className="sd-why-us-card" data-aos="zoom-in"><i className="fas fa-handshake"></i><span> Long-Term Partnership</span></div>
        </div>
      </section>

      <section id="contact" className="sd-cta">
        <h2 data-aos="fade-up">Let’s Build Your Software Together</h2>
        <a href="mailto:info@oakyaitservices.com" className="sd-btn">Get Your Free Consultation</a>
      </section>

    </div>
  )
}

export default SoftwareDevelopment